
(function(){
  if(!/Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)) return;
  const vv = window.visualViewport;
  let spacer = null, active = null, baseline = 0, engaged = false;
  const openT = 70, closeT = 45;

  function makeSpacer(h){
    if(!spacer){
      spacer = document.createElement("div");
      spacer.id = "kb-spacer-search";
      document.body.appendChild(spacer);
    }
    spacer.style.height = h+"px";
  }
  function resetSpacer(){
    if(spacer) spacer.style.height = "0px";
  }

  function adjust(){
    if(!active) return;
    const h = vv ? vv.height : window.innerHeight;
    if(!baseline) baseline = h;
    const diff = baseline - h;

    if(diff > openT && !engaged){
      engaged = true;
      makeSpacer(diff + diff/4);
      setTimeout(()=>{ try{ active.scrollIntoView({block:"nearest",behavior:"smooth"}); }catch(e){} },60);
    } else if(engaged && diff <= closeT){
      engaged = false;
      resetSpacer();
      baseline = h;
    }
  }

  document.addEventListener("focusin", e=>{
    const el = e.target;
    if(!el.closest(".support-search")) return;
    if(el.tagName!=="INPUT") return;
    active = el;
    baseline = vv ? vv.height : window.innerHeight;
    engaged = false;
    setTimeout(adjust,120);
  });

  document.addEventListener("focusout", e=>{
    if(e.target===active){
      setTimeout(()=>{
        const cur = document.activeElement;
        if(!cur || !cur.closest(".support-search")){
          engaged = false;
          resetSpacer();
          active = null;
          baseline = 0;
        }
      },180);
    }
  });

  (vv||window).addEventListener("resize", adjust);

  document.addEventListener("touchstart", e=>{
    if(engaged && !e.target.closest(".support-search")){
      engaged = false;
      resetSpacer();
      active = null;
      baseline = 0;
    }
  },{passive:true});
})();